import { Button, Div, JsonViewer, ModalWindow, MultilineInput, RefSerializer, RefString, Snack } from "@tblabs/truffle";
import { OrderEventsCalendar } from "../Components/OrderEventsCalendar";
import { OrderAsStepsPrinter } from "../Services/OrderAsStepsPrinter";
import { OrdersManager } from "../Services/OrdersManager";
import { StepFactory } from "../Services/StepFactory";
import { TicketToOrderConverter } from "../Services/TicketToOrderConverter";
import { TicketBuilder } from "./TicketBuilder";
import { Router } from "../Services/Router";
import { CustomerStepsPrinter } from "../Services/StepsPrinter";
import { SpecteamShopContentProvider } from "../Services/SpecteamShopContentProvider";
import { AgentsProvider } from "../Services/AgentsProvider";
import { TabsV2 } from "../Components/Utils/Tabs";
import { Icons } from "../Components/Utils/Icons";
import { Order } from "../Models/Order";
import { Ticket } from "../Models/Ticket";
import { XPrimaryButton } from "../Components/Utils/XPrimaryButton";
import { PaymentForm } from "../Models/Payment/PaymentForm";
import { BitcoinPriceProvider } from "../Steps/Payment/Services/BitcoinPriceProvider";


export class OrderGeneratorPage extends Div
{
    private order!: Order;

    constructor(
        private _manager: OrdersManager,
        private _router: Router,
        private _stepsFactory: StepFactory,
        private _agents: AgentsProvider,
        private _shop: SpecteamShopContentProvider,
        private orderIdToRegenerate?: string)
    {
        super();
    }

    async OnAppend(): Promise<void>
    {
        let order: Order = new Order();

        const ticketBuilder = new TicketBuilder(this._shop)

        ticketBuilder.OnChange.Subscribe(async (ticket: Ticket) =>
        {
            order = await this.Generate(ticket);
        });

        if (this.orderIdToRegenerate)
        {
            order = await this._manager.GetOne(this.orderIdToRegenerate) ?? new Order();
            ticketBuilder.LoadTicket(order.Meta.Ticket);
        }

        const ticketAsString = new RefString().Storable("order-creator:ticket-as-string");
        const view = new RefString("Generator").Storable("order-generator-page");

        this.Append(
            new MultilineInput(ticketAsString).Rows(5),
            new Button("Z tiketu").OnClick(() =>
            {
                ticketBuilder.LoadTicket(JSON.parse(ticketAsString.value));
            }),
            new TabsV2(view)
                .Add(Icons.Plus, "Generator", () => ticketBuilder)
                .Add(Icons.Eye, "Widok Admina", () => new OrderAsStepsPrinter(this._router, this._agents, order))
                .Add(Icons.User, "Widok Klienta", () => new CustomerStepsPrinter(order))
                .Add(Icons.Calendar, "Kalendarz", () => new OrderEventsCalendar(order))
                .Add(Icons.Edit, "Raw", () => new JsonViewer(RefSerializer.Flatenize(order)))
                .Add(Icons.Edit, "Json", () =>
                    new MultilineInput(
                        new RefString(
                            RefSerializer.Serialize(order),
                        )).Rows(20)),

            new XPrimaryButton("Dodaj do zamówień", Icons.Save, async (btn) =>
            {
                btn.Disabled();
                await this._manager.Add(order);
                new Snack("Dodano do zamówień", "Zamówienie #" + order.ShortId, { autoCloseTimeout: 1500 });
            }).MarginTop(16)
        );
    }

    public async Generate(ticket: Ticket): Promise<Order>
    {
        try
        {
            let btcValueInPln = -1;
            if (ticket.BasketPaymentForm == PaymentForm.Crypto)
            {
                const _bitcoinPriceProvider = new BitcoinPriceProvider();
                await _bitcoinPriceProvider.Update();
                btcValueInPln = _bitcoinPriceProvider?.BtcValueInPln.value ?? (-1);
            }

            const _converter = new TicketToOrderConverter(this._stepsFactory);
            this.order = _converter.Convert(ticket, btcValueInPln);
            this.order.SelfSetup();
            new Snack("Wygenerowano", "Zamówienie #" + this.order.ShortId, { autoCloseTimeout: 1500 });
            return this.order;
        }
        catch (e: any)
        {
            new Snack("Błąd generowania!", e.message, { autoCloseTimeout: 5000 });
            console.error(e);
            return new Order();
        }
    }
}
